<template>
    <div class="recruit">
        <transition name="modal">
            <div class="modal" v-if="modalOpen">
                <div class="modal__inner">
                    <p class="title" v-html="$t('recruit.section02.modal.title')"></p>
                    <p class="desc" v-html="$t('recruit.section02.modal.desc')"></p>
                    <ul class="recruit-list">
                        <li class="recruit-list__item">
                            <!-- category, a tag addclass is-active / a tag add herf-->
                            <p class="category is-active" v-html="$t('recruit.section02.modal.category01')"></p>
                            <a class="is-active" href="https://www.jobkorea.co.kr/Recruit/GI_Read/34781638" target="_blank" v-html="$t('recruit.section02.modal.site01')"></a>
                            <a v-html="$t('recruit.section02.modal.site02')"></a>
                        </li>
                        <li class="recruit-list__item">
                            <p class="category" v-html="$t('recruit.section02.modal.category02')"></p>
                            <a v-html="$t('recruit.section02.modal.site01')"></a>
                            <a v-html="$t('recruit.section02.modal.site02')"></a>
                        </li>
                        <li class="recruit-list__item">
                            <p class="category" v-html="$t('recruit.section02.modal.category03')"></p>
                            <a v-html="$t('recruit.section02.modal.site01')"></a>
                            <a v-html="$t('recruit.section02.modal.site02')"></a>
                        </li>
                        <li class="recruit-list__item">
                            <p class="category" v-html="$t('recruit.section02.modal.category04')"></p>
                            <a v-html="$t('recruit.section02.modal.site01')"></a>
                            <a v-html="$t('recruit.section02.modal.site02')"></a>
                        </li>
                    </ul>
                    <button class="modal-close" @click="modalOpen = false"></button>
                </div>
            </div>
        </transition>
        <Visual :title="'RECRUIT'" :background="'recruit'"/>
        <div class="box-wrapper">
            <div class="shape-wrapper" v-if="$resize && $mq.above(1024)">
                <div class="shape1"  v-parallax="0.2"></div>
                <div class="shape2"  v-parallax="-0.4"></div>
            </div>
            <GradientBox class="recruit-box" :transition="'gradient-box'">
                <div class="recruit-box__label is-lato">RECRUIT</div>
                <div class="recruit-box__text">
                    <p class="title is-lato">CUBE PLATFORM<br>DIRECTIVITY</p>
                    <p class="desc" v-html="$t('recruit.desc01')"></p>
                </div>
            </GradientBox>
            <div class="side-desc">
                <p v-html="$t('recruit.desc02')"></p>
            </div>
        </div>
        <div class="content">
            <Scrollama @step-enter="setVisible" :offset="0.8">
            <div class="section01">
                <div class="section__inner">
                    <p class="section-title" v-html="$t('recruit.section01.title')"></p>
                    <ul class="welfare">
                        <sequential-entrance delay="150" animation="listIn">
                            <li class="item" v-for="(item, index) in 12" :key="index">
                                <div :class="['symbol', 'welfare-' + item]"></div>
                                <div class="desc">
                                    <p v-html="$t('recruit.section01.desc' + item)"></p>
                                </div>
                            </li>
                        </sequential-entrance>
                    </ul>
                </div>
            </div>
            <div class="section02" @click="modalOpen = true">
                <p class="title" v-html="$t('recruit.section02.title')"></p>
            </div>
            </Scrollama>
        </div>
    </div>
</template>

<script>
import 'intersection-observer'
import Scrollama from 'vue-scrollama'
import Visual from '@/components/common/Visual'
import GradientBox from '@/components/common/GradientBox'
export default {
    name: 'Recruit',
    components: { Scrollama, Visual, GradientBox },
    metaInfo: {
        titleTemplate: '%s | RECRUIT',
        meta: [
            { name: 'description', content: `상식을 기반으로 발전하는 ‘큐브플랫폼’ 입니다.` },
            { name: 'property="og:description"', content: '상식을 기반으로 발전하는 ‘큐브플랫폼’ 입니다.' }
        ]
    },
    data: function () {
        return {
            modalOpen: false
        }
    },
    methods: {
        setVisible (el) {
            el.element.classList.add('is-active')
        }
    },
    computed: {
        locale: function () {
            return this.$store.getters.getLocale
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@keyframes gradient {
    0% {background-position: 0% 50%;}
    50% {background-position: 100% 50%;}
    100% {background-position: 0% 50%;}
}
@keyframes modal-inner {
    0% {transform: translate(-50%, -60%);}
    100% {transform: translate(-50%, -50%);}
}
@keyframes list-visible {
    0% {transform: translateY(30px); opacity: 0;}
    100% {transform: translateY(0); opacity: 1;}
}
.listIn {
    position: relative;
    animation: list-visible 1000ms;
}
@keyframes side-desc {
    0% {opacity: 0; transform: translateY(40px);}
    100% {opacity: 1; transform: translateY(0vw);}
}
@keyframes side-desc-m {
    0% {opacity: 0; transform: translateY(4vw);}
    100% {opacity: 1; transform: translateY(0vw);}
}
.modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000, $alpha: 0.4);

    &__inner {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 1000px;
        height: 480px;
        padding: 50px 60px;
        background: #fff;
        transform: translate(-50%, -50%);
        animation: modal-inner 500ms forwards;

        .title {
            color: #444;
            font-size: 30px;
            line-height: 30px;
            letter-spacing: -1px;
        }
        .desc {
            margin-top: 20px;
            color: #999;
            font-size: 16px;
            line-height: 16px;
            letter-spacing: -1px;;
        }
        .recruit-list {
            margin-top: 40px;
            border: solid #7f7f7f;
            border-width: 1px 0 1px;

            &__item {
                position: relative;
                padding: 12px 0;
                border-bottom: 1px solid #dbdbdb;
                text-align: right;

                .category {
                    position: absolute;
                    top: 50%;
                    left: 20px;
                    color: #444;
                    font-size: 19px;
                    line-height: 19px;
                    letter-spacing: -1px;
                    transform: translateY(-50%);
                    opacity: 0.4;

                    &.is-active {
                        opacity: 1;
                    }
                }
                a {
                    display: inline-block;
                    width: 160px;
                    height: 42px;
                    background: #ebebeb;
                    color: #666666;
                    font-size: 14px;
                    letter-spacing: -1px;;
                    line-height: 42px;
                    text-align: center;
                    opacity: 0.4;
                    cursor: default;

                    &.is-active {
                        opacity: 1;
                        cursor: pointer;

                        &:hover {
                            @include gradient-45;
                            background-size: 800%;
                            color: #fff;
                            animation: gradient 18s infinite;
                        }
                    }
                }
            }
        }
        .modal-close {
            position: absolute;
            top: 50px;
            right: 60px;
            width: 40px;
            height: 40px;
            border: none;
            background: none;
            cursor: pointer;
            outline: none;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

            &::before,
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                height: 1px;
                background: #a6a6a6;
                transform: translate(-50%, -50%);
            }
            &::before {
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after {
                transform: translate(-50%, -50%) rotate(-45deg);
            }
            &:hover::before,
            &:hover::after {
                background: #666;
            }
        }
    }
    @include under-tablet {
        &__inner {
            width: calc(100% - 56px);
            padding: 6vw;
            height: initial;
            .title {
                font-size: 5.4vw;
                line-height: 5.4vw;
            }
            .desc {
                margin-top: 4vw;
                font-size: 3.8vw;
                line-height: 6vw;
            }
            .recruit-list {
                overflow-y: scroll;
                height: 80vw;
                margin-top: 6vw;
                &__item {
                    padding: 4vw 0;
                    .category {
                        font-size: 4vw;
                        line-height: 6vw;
                        left: 0;
                        text-align: left;
                    }
                    a {
                        width: 40vw;
                        height: 10vw;
                        margin-left: 10vw;
                        font-size: 4vw;
                        line-height: 10vw;
                        &:last-child {
                            margin-top: 2vw;
                        }
                    }
                }
            }
            .modal-close {
                top: 6vw;
                right: 6vw;
                width: 5.4vw;
                height: 5.4vw;
            }
        }
    }
    @include mobile {
        &__inner {
            width: calc(100% - 40px);
        }
    }
}
.modal-enter-active,
.modal-leave-active {
    transition: opacity 250ms;
}
.modal-enter,
.modal-leave-to{
    opacity: 0;
}
.modal-enter-to,
.modal-leave {
    opacity: 1;
}
@include over-desktop {
    .box-wrapper {
        position: relative;
        top: -70px;
        width: 1200px;
        margin: 0 auto;

        .shape-wrapper {
            position: relative;
            width: 1200px;
            height: 100%;
            z-index: -1;
            margin: 0 auto;
            .shape1 {
                position: absolute;
                top: -240px;
                left: 25%;
                width: 320px;
                height: 343px;
                background: url(../assets/image/recruit/shape_01.png) no-repeat center;
                background-size: 100% auto;
            }
            .shape2 {
                position: absolute;
                top: 450px;
                right: -5%;
                width: 126px;
                height: 115px;
                background: url(../assets/image/recruit/shape_02.png) no-repeat center;
                background-size: 100% auto;
            }
        }
    }
    .recruit-box {
        width: 386px;
        height: 386px;
        padding: 70px;
        white-space: nowrap;

        @keyframes label {
            0% {opacity: 0; transform: translateX(-100px);}
            100% {opacity: 1; transform: translateX(0);}
        }
        &__label {
            position: absolute;
            top: 30px;
            left: 340px;
            font-weight: 700;
            font-size: 16px;
            color: #fff;
            letter-spacing: 16px;
            animation: label 750ms ease 750ms backwards;

            &::before {
                content: '';
                display: block;
                position: absolute;
                top: 50%;
                left: -80px;
                width: 60px;
                height: 1px;
                background: #fff;
                opacity: 0.3;
            }
        }
        &__text {
            color: #fff;
            .title {
                font-size: 30px;
                line-height: 36px;
            }
            .desc {
                margin-top: 38px;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: -1.5px;
                opacity: 0.7;
            }
        }
    }
    .side-desc {
        position: absolute;
        left: 700px;
        bottom: 0;
        animation: side-desc 1000ms 250ms backwards;

        p {
            color: #444;
            font-size: 18px;
            line-height: 40px;
            letter-spacing: -1.5px;
        }
    }
    .content {
        position: relative;
        width: 100%;
        margin-top: 30px;

        .section-title {
            color: #444;
            font-size: 30px;
            line-height: 30px;
            letter-spacing: -1px;

            &::before {
                content: '';
                display: inline-block;
                width: 71px;
                height: 10px;
                margin-right: 25px;
                margin-bottom: 3px;
                background: url(../assets/image/common/before-title.svg) no-repeat center;
                background-size: 100% auto;
                vertical-align: middle;
            }
        }
        .section__inner {
            position: relative;
            width: 1200px;
            margin: 0 auto;
        }
        .section01 {
            position: relative;
            z-index: 1;
            &::before {
                content: '';
                display: block;
                position: absolute;
                top: 60px;
                left: 50%;
                width: 1200px;
                height: 680px;
                background: #f4f4f4;
                transform: translateX(-50%);
            }
            .welfare {
                margin-top: 30px;

                &::after {
                    content: '';
                    display: block;
                    clear: both;
                }

                .item {
                    margin-top: 70px;
                    float: left;
                    width: 150px;
                    height: 235px;
                    margin-left: 60px;
                    text-align: center;

                    &:nth-child(1),
                    &:nth-child(7) {
                        margin-left: 0;
                    }
                    .symbol {
                        width: 150px;
                        height: 150px;
                        @for $i from 1 to 13 {
                            &.welfare-#{$i} {
                                background: url(../assets/image/recruit/welfare_#{$i}.png) no-repeat center;
                                // background-size: 100% auto;
                            }
                        }
                    }
                    .desc {
                        margin-top: 28px;
                        color: #444;
                        font-size: 16px;
                        line-height: 22px;
                        letter-spacing: -1px;
                    }
                }
            }
        }
        .section02 {
            position: relative;
            width: 100%;
            height: 500px;
            background: url(../assets/image/recruit/more_background.png) no-repeat center;
            background-size: cover;
            cursor: pointer;

            .title {
                position: absolute;
                top: calc(50% + 30px);
                left: 50%;
                color: #fff;
                font-size: 30px;
                line-height: 30px;
                letter-spacing: -1px;
                text-align: center;
                transform: translate(-50%, -50%);
            }
        }
    }
    .gradient-box-enter-active,
    .gradient-box-leave-active {
        transition: transform 1000ms;
    }
    .gradient-box-enter,
    .gradient-box-leave-active {
        transform: translateX(25px);
    }
    .section01 {
        .section__inner {
            .section-title {
                opacity: 0;
                transform: translateX(-40px);
                transition: opacity 1000ms, transform 1000ms;
            }
            .welfare {
                min-height: 610px;
                span {
                    display: none;
                }
            }
        }
    }
    .section01.is-active {
        .section__inner {
            .section-title {
                opacity: 1;
                transform: translateX(0);
            }
            .welfare {
                span {
                    display: block;
                }
            }
        }
    }
    .section02 {
        opacity: 0;
        transition: opacity 1000ms;
    }
    .section02.is-active {
        opacity: 1;
    }
}
@media (min-width: 1201px) {
    .content {
        .section01 {
            &::before {
                width: 1600px;
            }
        }
    }
}
@include desktop-small {
    .box-wrapper {
        width: calc(1024px - 56px);
        .shape-wrapper {
            width: 1024px;
        }
    }
    .side-desc  {
        left: 500px;
        p {
            font-size: 17px;
        }
    }
    .content {
        .section__inner {
            width: calc(1024px - 56px);
        }
        .section01 {
            &::before {
                width: calc(1024px - 56px);
                height: 985px;
            }
            .welfare {
                width: 810px;
                margin: 30px auto 0;
                .item {
                    &:nth-child(1),
                    &:nth-child(7) {
                        margin-left: 60px;
                    }
                    &:nth-child(1),
                    &:nth-child(5),
                    &:nth-child(9) {
                        margin-left: 0;
                    }
                }
            }
        }
    }
}
@include under-tablet {
    .box-wrapper {
        width: calc(100% - 56px);
        margin-left: 28px;
        transform: translateY(-10vw);
    }
    .recruit-box {
        padding: 6vw;
        &__label {
            display: none;
        }
        &__text {
            color: #fff;
            .title {
                font-size: 4.4vw;
            }
            .desc {
                margin-top: 6vw;
                font-size: 2.8vw;
                opacity: 0.7;
            }
        }
    }
    .side-desc {
        margin-top: 10vw;
        color: #444;
        font-size: 3.6vw;
        line-height: 8vw;
        letter-spacing: -0.3vw;
        text-align: center;
        animation: side-desc-m 1000ms 250ms backwards;
    }
    .section01 {
        position: relative;
        z-index: 1;
        padding: 0 28px;
        .section-title {
            font-size: 5.4vw;
            text-align: center;

            &::before {
                content: '';
                display: block;
                margin: 0 auto 4vw;
                width: 20vw;
                height: 3vw;
                background: url(../assets/image/common/before-title.svg) no-repeat center;
                background-size: 100% auto;
            }
        }
        .welfare {
            margin-top: 10vw;
            padding: 4vw 28px;
            background: #f4f4f4;
            .item {
                position: relative;
                padding-top: 4vw;
                &:last-child {
                    padding-bottom: 4vw;
                }
                .symbol {
                    width: 20vw;
                    height: 20vw;
                    @for $i from 1 to 13 {
                        &.welfare-#{$i} {
                            background: url(../assets/image/recruit/welfare_#{$i}.png) no-repeat center;
                            background-size: 100% auto;
                        }
                    }
                }
                .desc {
                    display: block;
                    position: absolute;
                    top: 50%;
                    left: 24vw;
                    transform: translateY(-50%);
                    p {
                        color: #444;
                        font-size: 3.8vw;
                        line-height: 6vw;
                        letter-spacing: -0.2vw;
                        vertical-align: middle;
                    }
                }
            }
        }
    }
    .section02 {
        position: relative;
        margin-top: -10vw;
        height: 66vw;
        background: url(../assets/image/recruit/more_background_m.png) no-repeat center;
        background-size: cover;
        margin-top: 3vw;
        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            font-size: 5.4vw;
            color: #fff;
            transform: translate(-50%, -50%);
        }
    }
    .section01 {
        .section__inner {
            .section-title {
                opacity: 0;
                transform: translateY(4vw);
                transition: opacity 1000ms, transform 1000ms;
            }
            .welfare {
                min-height: 300vw;
                span {
                    display: none;
                }
            }
        }
    }
    .section01.is-active {
        .section__inner {
            .section-title {
                opacity: 1;
                transform: translateX(0);
            }
            .welfare {
                span {
                    display: block;
                }
            }
        }
    }
    .section02 {
        opacity: 0;
        transition: opacity 1000ms;
    }
    .section02.is-active {
        opacity: 1;
    }
}
@include mobile {
    .box-wrapper {
        width: calc(100% - 40px);
        margin-left: 20px;
    }
    .section01 {
        padding: 0 20px;
        .welfare {
            padding: 4vw 20px;
        }
    }
}
.section01 {
    display: none !important;
}
</style>
<style scoped>
.side-desc p >>> span,
.welfare .item .desc >>> span {
    color: #e77190;
}
</style>



// WEBPACK FOOTER //
// src/views/Recruit.vue